import BigNumber from 'bignumber.js'

import type { TradeSwap } from '@blade/blockchain-types'

export type SwapDetails = {
  amountIn: BigNumber
  amountInUsd: BigNumber
  amountOut: BigNumber
  amountOutUsd: BigNumber
  tokenPriceUsd: BigNumber
  tokenPriceNative: BigNumber
  marketCapUsd: BigNumber
}

export const fromDto = (
  dto: NonNullable<TradeSwap['swapDetails']>,
): SwapDetails => {
  return {
    amountIn: BigNumber(dto.amountIn),
    amountInUsd: BigNumber(dto.amountInUsd),
    amountOut: BigNumber(dto.amountOut),
    amountOutUsd: BigNumber(dto.amountOutUsd),
    tokenPriceNative: BigNumber(dto.tokenPriceInNative),
    tokenPriceUsd: BigNumber(dto.tokenPriceInUsd),
    marketCapUsd: BigNumber(dto.marketCap),
  }
}
